export default "__VITE_PUBLIC_ASSET__745bd116__"